import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { ReactComponent as SuccessIcon } from "../../assets/icons/success-badge.svg";
import { useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import BottomFullWidthButtonContainer from "../../components/shared/BottomFullWidthButtonContainer";

function CashoutSuccessPage() {
  const navigate = useNavigate();

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            برداشت موفق
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          alignItems: "stretch",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            px: "24px",
            pt: 8,
            pb: 2,
          }}
        >
          <SuccessIcon width={50} height={55} />
          <Typography
            align="center"
            mt={2}
            variant="body1"
            color="primary.main"
          >
            برداشت با موفقیت انجام شد.
          </Typography>
          <Typography align="center" mt={2} variant="body2" color="grey.4">
            مبلغ تسویه شده حداکثر تا ۲۴ ساعت آینده به حساب شما منتقل خواهد شد.
          </Typography>
        </Box>
        <BottomFullWidthButtonContainer>
          <Button
            onClick={() => {
              navigate("/app/receipt", { state: { fromCashOut: true } });
            }}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            مشاهده صورت‌حساب
          </Button>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default CashoutSuccessPage;
